import Modem, { ModemDialOptions } from "../api/Modem";
import SecretHandle, { Secret, SecretId, SecretSpec } from "./secret";

type SecretListFilterType = "id" | "label" | "name" | "names";

export type SecretListFilters = Map<SecretListFilterType, Array<string>>;
export type SecretListResult = Array<Secret>;

export type SecretListQueryOptions = {
    filters?: SecretListFilters
};

type SecretCreateResult = {
    ID: SecretId
};

export default class Secrets {
    public static async list(modem: Modem, queryOptions: SecretListQueryOptions = {}) {
        const query = new Map();
        if (queryOptions.filters) query.set("filters", JSON.stringify(Object.fromEntries(queryOptions.filters)));

        const call: ModemDialOptions = {
            path: "/secrets",
            method: "GET",
            query: query
        };

        return await modem.dial(call) as SecretListResult;
    }

    public static async create(modem: Modem, spec: SecretSpec) {
        const call: ModemDialOptions = {
            path: "/secrets/create",
            method: "POST",
            body: spec
        };

        const result = await modem.dial(call) as SecretCreateResult;
        return new SecretHandle(modem, result.ID);
    }

    public static async exists(modem: Modem, name: string) {
        const filters = new Map();
        filters.set("name", Array.of(name));

        const secretList = await Secrets.list(modem, { filters });
        return { exists: secretList.length > 0, handle: secretList.length > 0 ? SecretHandle.fromSecret(modem, secretList[0]) : undefined };
    }

    public static getHandle(modem: Modem, id: SecretId) {
        return new SecretHandle(modem, id);
    }
}